import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ApplicationSeatPart } from './application-seat/application-seat.part';
import { ChangeLanguagePart } from './change-language/change-language.part';
import { ResetParticipantVideosPart } from './reset-participant-videos/reset-participant-videos.part';

@Component({
	selector: 'acc-application-management-dialog-part',
	standalone: true,
	imports: [
		ChangeLanguagePart,
		ResetParticipantVideosPart,
		ApplicationSeatPart
	],
	templateUrl: './management-dialog.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './management-dialog.part.scss'
})
export class AccApplicationManagementDialogPart {
}
